<template>
  <v-dialog
      v-model="show"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
      @keydown.enter="agree"
  >
    <v-card class="confirm-card">
      <v-toolbar :color="options.color" dark dense flat>
        <v-toolbar-title class="white--text center-title">{{ title }}
          <v-fab-transition>
            <v-btn
                dark
                color="white"
                fab
                icon
                small
                absolute
                right
                top
                @click.native="cancel"
            >
              <v-icon>fal fa-times-circle</v-icon>
            </v-btn>
          </v-fab-transition>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="center-question" v-dompurify-html="message"></v-card-text>
      <v-card-actions class="pt-0 center-actions">
        <v-spacer></v-spacer>
        <v-btn
            @click.native="cancel"
            color="#6D787E"
            outlined large
            class="action-btns"
            >{{ noText }}</v-btn>
        <v-btn
            @click.native="agree"
            dark large depressed
            class="action-btns"
            :color="options.color"
            >{{ title }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    noText: 'Cancel',
    options: {
      color: 'primary',
      width: 450,
      zIndex: 200
    }
  }),
  computed: {
    show: {
      get() {
        return this.dialog
      },
      set(value) {
        this.dialog = value
        if (value === false) {
          this.cancel()
        }
      }
    }
  },
  methods: {
    open(title, message, options, noText) {
      this.dialog = true
      this.title = title
      this.noText = noText || this.noText
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .center-title {
    text-align: center;
    width: 100%;
    font-family: var(--font-family);
    font-weight: 800;
    font-size: 18px;
  }

  .center-question.v-card__text,
  .center-question {
    text-align: center;
    font-size: 16px;
    color: #253035;
    padding: 33px;
  }

  .v-dialog > .v-card > .v-card__actions.center-actions > .spacer {
    flex-grow: unset!important;
  }

  .v-dialog > .v-card > .v-card__actions.center-actions,
  .center-actions {
    padding-bottom: 26px;
    justify-content: center;
  }
</style>
<style lang="scss" scoped>

  .v-application#alert-details-app .action-btns.v-btn .v-btn__content {
    font-family: var(--font-family);
    font-weight: 800;
    font-size: 14px;
    min-width: 125px;
    min-height: 40px;
  }

  .v-application--is-ltr .v-card__actions > .action-btns.v-btn.v-btn + .v-btn {
    margin-left: 20px;
  }

  .confirm-card .v-btn--absolute.v-btn--right, .v-btn--fixed.v-btn--right {
    right: 4px
  }

  .confirm-card .v-btn--fab.v-size--small.v-btn--absolute.v-btn--top{
    top: 4px
  }

</style>